<template>
    <div class="my-8">
        <CustomScenarioChart :period="customChartPeriod" category="age" />

        <div class="mx-auto mb-8 d-flex flex-column justify-space-between align-center" elevation="3">
            <ConsiderVoluntaryPayments />
            <ScheduleRMPayments />
            <InterestRateScenarioAndPVARate />
            <ImportantData />
            <!-- <AuditButton v-if="!isResultSaved" /> -->
        </div>
    </div>
</template>

<script>
import CustomScenarioChart from '../Charts/CustomScenarioChart.vue';
import ConsiderVoluntaryPayments from './ConsiderVoluntaryPayments.vue';
import ScheduleRMPayments from './ScheduleRMPayments.vue';
import InterestRateScenarioAndPVARate from './InterestRateScenarioAndPVARate.vue';
import ImportantData from './ImportantData/ImportantData.vue';
// import AuditButton from '../AuditButton.vue';

export default {
    components: {
        CustomScenarioChart,
        ConsiderVoluntaryPayments,
        ScheduleRMPayments,
        InterestRateScenarioAndPVARate,
        ImportantData
        // AuditButton
    },
    computed: {
        customChartPeriod() {
            return (
                this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues
                    .maxFutureAgeDiff - 1
            );
        }
    }
};
</script>

<style scoped></style>
